import { useState } from 'react';
import styled from 'styled-components';

import CompanyLogo from '../../assets/logo.png';

import { LogIn, Search } from 'lucide-react';

const Nav = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');

  return (
    <Header>
      <div>
        <NavBar>
          <Logo className="manrope-regular" href="#">
            <SiteLogo height={40} src={CompanyLogo} alt="logo" />
            tackoom
          </Logo>
          <Hamburger onClick={() => setIsOpen(!isOpen)}>
            <span />
            <span />
            <span />
          </Hamburger>

          <Menu isOpen={isOpen}>
            <MenuLink className="manrope-semibold" href="https://www.tackoom.com/login">
              For Seekers
            </MenuLink>
            <MenuLink className="manrope-semibold" href="https://tackoom.com/registration/consultant">
              For Advisors
            </MenuLink>
            <MenuLink className="manrope-semibold" href="https://www.tackoom.com/registration/enterprise">
              For Enterprise
            </MenuLink>
            <MenuLink className="manrope-semibold" href="https://www.tackoom.com/login">
              Book Your Session
            </MenuLink>
          </Menu>

          <CTOMenuWrapper>
            <Menu isOpen={isOpen}>
              <MenuLink
                className="sign-in manrope-semibold"
                href="https://www.tackoom.com/login"
              >
                Sign in <LogIn />
              </MenuLink>
            </Menu>
          </CTOMenuWrapper>
        </NavBar>
      </div>
    </Header>
  );
};

export default Nav;

const CTOMenuWrapper = styled.div`
  display: flex;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const SiteLogo = styled.img`
  border-radius: 5rem;
`;

const Header = styled.header`
  background-color: #ffffff;

  position: fixed;
  justify-content: center;
  width: 100%;
  z-index: 99;
  padding: 1rem;
`;

const NavBar = styled.nav`
  width: 100%;
  max-width: 1150px;
  display: flex;

  justify-content: space-between;
  @media (max-width: 768px) {
    justify-content: space-between;
  }
  align-items: center;
  /* max-width: 1200px; */
  flex-wrap: wrap;
  margin-left: 50%;
  transform: translateX(-50%);
`;

const Hamburger = styled.div`
  display: none;
  flex-direction: column;
  cursor: pointer;

  span {
    height: 2px;
    width: 25px;
    background-color: #ea5d0f;
    margin: 4px 0;
    border-radius: 5px;
    transition: all 0.3s ease-in-out;
  }

  @media (max-width: 768px) {
    display: flex;
  }
`;

const Menu = styled.div<{ isOpen: boolean }>`
  display: flex;
  align-items: center;
  background-color: white;
  z-index: 1;

  @media (min-width: 768px) {
    border-radius: 0.5rem;
  }
  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    max-height: ${({ isOpen }) => (isOpen ? '300px' : '0')};
    overflow: hidden;
    transition: max-height 0.3s ease-in-out;
    margin-top: 1rem;
  }
  .sign-in {
    background-color: #000000;
    color: white;
    border-radius: 0.5rem;
    &:hover {
      color: #dbe8ff;
      background-color: #393939;
    }
  }
`;

const MenuLink = styled.a`
  svg {
    height: 14px;
  }

  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 1rem;
  text-decoration: none;
  color: #105299;
  font-size: 0.8rem;
  transition: color 0.3s ease-in-out;

  &:hover {
    color: #1769aa;
  }

  @media (max-width: 768px) {
    &:hover {
      border-radius: 0.5rem;
      background-color: #ffefe3;
    }
    padding: 1rem;
    width: 100%;
    text-align: center;
  }
`;

const Logo = styled.a`
  display: flex;
  align-items: center;
  color: #0374df;
  text-decoration: none;
  font-weight: 800;
  font-size: 1.5rem;
`;
